import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class ContractsMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.contracts.contractsMapperError"));

        Object.setPrototypeOf(this, ContractsMapperError.prototype);
    }
}